




import { defineClassComponent, useQuery } from '@/hooks'
import { onBeforeMount } from '@vue/composition-api'
import { redirectTo } from '@/router'

export default defineClassComponent(
  () =>
    class {
      constructor() {
        onBeforeMount(() => {
          redirectTo(this.query.pageName as any, this.query.pageQuery)
        })
      }

      query = useQuery<{
        pageName: string
        pageQuery: any
      }>({
        pageQuery: {
          transformer: JSON.parse,
        },
      })
    },
)
